/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig';

export class UpdateRestoreAccountConnectivityConfigResponse {
  'restoreAccountConfig': RestoreAccountConnectivityConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountConfig",
      "baseName": "restoreAccountConfig",
      "type": "RestoreAccountConnectivityConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateRestoreAccountConnectivityConfigResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

